'use client';

import { getFragmentData } from '@/__generated__';
import { EventEntryFragment } from '@/__generated__/graphql';
import HideOnScroll from '@/components/HideOnScroll';
import PageTicket from '@/components/PageTicket';
import Box from '@/components/ui/Box';
import Container from '@/components/ui/Container';
import Grid from '@/components/ui/Grid';
import Txt from '@/components/ui/Txt';
import { EVENT_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { parseProgram } from '@/lib/parsers/categories';
import { useColorScheme } from '@/lib/parsers/common';
import useScrollPercentage from '@/lib/utils/useScrollPercentage';
import * as styles from './EventLayout.css';

const EventLayoutBanner = (props: EventEntryFragment) => {
  const { programCategory, status, onSale } = props;

  const card = getFragmentData(EVENT_CARD_FRAGMENT, props);
  const program = parseProgram(programCategory);

  const isExpired = status === 'expired';

  const pos = useScrollPercentage();

  const { colorScheme: colorSet } = useColorScheme(program?.colorScheme, 'pink');

  if (!onSale) return null;

  return (
    <HideOnScroll direction="up" in={25 < pos && pos < 75}>
      <Box colorSet={!isExpired ? colorSet : 'error'} paper className={styles.banner}>
        <Container cx={{ mY: '2xs' }}>
          <Grid rowGutter>
            <Grid.Col lg={7} cx={{ display: 'flex', alignItems: 'center' }}>
              <Txt variant="h6" cx={{ mB: 'none' }}>
                {card.entryTitle}
              </Txt>
            </Grid.Col>
            <Grid.Col offsetLg={1} lg={4}>
              <PageTicket data={card} TicketBtnProps={{ size: 'normal' }} />
            </Grid.Col>
          </Grid>
        </Container>
      </Box>
    </HideOnScroll>
  );
};

export default EventLayoutBanner;
